import React, { ReactNode, useState } from 'react'

import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Typography,
} from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'
import { spacing } from '@material-ui/system'
import { Helmet } from 'react-helmet'

import { NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom'
import {
  Paginator,
} from 'src/components/Table'
import styled from 'styled-components'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

const Divider = styled(MuiDivider)(spacing)

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)

export interface DialogProps {
  open: boolean
  handleClose: () => void
  onSave: () => void
}

interface DialogInfo {
  title: string
  Dialog: React.FC<DialogProps>
}

interface ListPageProps {
  title: string
  paginator: Paginator
  dialogs?: DialogInfo[]
  children: ReactNode
}

export const ListPage = (props: ListPageProps) => {
  const { title, paginator, dialogs = [], children } = props
  const initial = dialogs.map(() => false)
  const [dialogOpen, setDialogOpen] = useState(initial)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <React.Fragment>
      <Helmet title={title} />
      {dialogs.map(({ Dialog }, index) => {
        return (
          <React.Fragment key={index}>
            {dialogOpen[index] && (
              <Dialog
                open={dialogOpen[index]}
                handleClose={() => {
                  dialogOpen[index] = false
                  setDialogOpen([...dialogOpen])
                }}
                onSave={paginator.refresh}
              />
            )}
          </React.Fragment>
        )
      })}
      <Grid justify="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            {title}
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/">
              Dashboard
            </Link>
            <Typography>{title}</Typography>
          </Breadcrumbs>
        </Grid>
        {!!dialogs.length && (
          <Grid item>
            <div>
              <IconButton color="primary" onClick={handleClick}>
                <AddIcon />
              </IconButton>
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                {dialogs.map(({ title }, index) => (
                  <MenuItem
                    key={title}
                    onClick={() => {
                      handleClose()
                      dialogOpen[index] = true
                      setDialogOpen([...dialogOpen])
                    }}
                  >
                    {title}
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </Grid>
        )}
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          { children }
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
